import { NodeData } from './NodeData';
import { BlockType } from './../compiler/factory/BlockType';
import { Node, NodeCoordinates, Port } from 'beautiful-react-diagrams/@types/DiagramSchema';
import { ElementType, ReactNode } from 'react';
import { CustomNode } from './CustomNode';
import { GuranteedRoot } from './GuranteedRoot';
import DiagramIDE from '../ide/DiagramIDE';


export class OutputNode extends GuranteedRoot implements CustomNode {
    id: string;
    coordinates: NodeCoordinates;
    content: ReactNode;
    inputs: Port[];
    data: NodeData;
    render: (props: Omit<Node<any>, 'coordinates'>) => ElementType | ReactNode;
    blockType: BlockType;
    constInputs: any[];

    /**
     * 
     * @param content content of this node
     * @param coordinates inital coordinates of the node
     * @param numInputs the number of input ports this node should have
     * @param blockType the type of the assembly block created (for phasing out assConstructor)
     * @param constInputs constant inputs that assembly block takes.
     * @param data data of the node (any object; should contain assConstructor)
     * @param render renderer used to render
     * ! ^ data is kinda weird. need to figure out how to replace it with more concrete/safe types.
     */
    constructor(content: ReactNode,
        coordinates: NodeCoordinates,
        numInputs: number,
        blockType: BlockType,
        constInputs: any[],
        data: NodeData,
        render: (props: Omit<Node<any>, 'coordinates'>) => ElementType | ReactNode) {
        super();
        this.id = DiagramIDE.getID()
        this.coordinates = coordinates;
        this.content = content;
        this.data = data;
        this.render = render;

        this.blockType = blockType;
        this.constInputs = constInputs;

        console.log('Outputs id: ' + this.id);

        this.inputs = [];
        for (let i = 0; i < numInputs; i++) {
            let portId: string = `${this.id}-input-${i}`
            console.log('port id: ' + portId);
            let port: Port = { id: portId };
            this.inputs.push(port);
        }
    }



}